import React, {Component} from 'react';
import $ from "jquery/dist/jquery.js";

class Pagination extends Component {
    constructor(props) {
        super(props);
        this.state = {
            curPage: this.props.curPage,
            total:  this.props.total
        };
        this.handleClick = this.handleClick.bind(this);
        
    }
  
    componentWillReceiveProps(newProps) {
        this.setState({
            curPage: newProps.curPage,
            total: newProps.total
        });
    }

    handleClick(id) {
        
        if ($('#'+id).hasClass('active') || $('#'+id).parent().hasClass('disabled'))
            return;

        var a = id.split('_');       
        this.setState({
            curPage: Number(a[1])
        });
        this.props.onChangePage(Number(a[1]));
    }   

    render() {
        
        var getLPforPrev = () => {
            // eslint-disable-next-line
            this.state.curPage = this.state.curPage < 0 ? 0 : this.state.curPage > this.state.total ? this.state.total : this.state.curPage;
            var lp = this.state.curPage - 1 < 1 ? 1 : 
                        this.state.curPage - 1 >= this.props.visible ? 
                            Math.floor((this.state.curPage - 1) / this.props.visible) * this.props.visible : this.state.curPage - 1;
            return lp;
        }

        var getLPforNext = () => {
            // eslint-disable-next-line
            this.state.curPage = this.state.curPage < 0 ? 0 : this.state.curPage > this.state.total ? this.state.total : this.state.curPage;        
            var vis = Math.floor((this.state.curPage - 1) / this.props.visible) * this.props.visible;
            var lp = this.state.curPage + 1 > this.state.total ? this.state.total : 
                        this.state.curPage + 1 < this.state.total - this.props.visible ? 
                            vis + this.props.visible + 1 : this.state.curPage + 1;
            return lp;
        }

        var getLP = (index) => {
            var vis = Math.floor((this.state.curPage - 1) / this.props.visible) * this.props.visible;
            var d = this.state.curPage <= vis ? - this.props.visible : 0;
            var lp = index + 1 + vis + d;
    
            return lp;
        }        
        
        var pageNumbers = [];
        for (let i = 0; i < Math.min(this.state.total, this.props.visible); i++) {
            var lp = getLP(i);
            if (lp > this.state.total)
                break;
            pageNumbers.push(lp);
        }
        var renderPageNumbers = pageNumbers.map(number => {
            return (
                <li key={number} className={`${this.state.curPage === number ? 'active' :　'page'}`} >
                    <a  
                        className={`${this.state.curPage === number ? 'active' :　''}`}
                        id={`num_${number}`}                        
                        onClick={(id) => this.handleClick(`num_${number}`)}
                    >                
                    {number} 
                    </a>
                </li>
            );
        });

        return (
            <ul className="">
                <li className={`first ${this.state.curPage === 1 ? 'disabled' : 'page'}`}>
                    <a 
                        id={`first_1`} 
                        onClick={(id) => this.handleClick(`first_1`)}
                    >
                    <i className="fa fa-angle-double-left"></i>
                    </a>
                </li>
                <li className={`prev ${this.state.curPage === 1 ? 'disabled' : 'page'}`}>
                    <a 
                        id={`prev_${getLPforPrev()}`} 
                        onClick={(id) => this.handleClick(`prev_${getLPforPrev()}`)}
                    >
                    <i className="fa fa-angle-left"></i>
                    </a>
                </li>
                {renderPageNumbers}
                <li className={`next ${this.state.curPage === this.props.total ? 'disabled' : 'page'}`}>
                    <a 
                        id={`next_${getLPforNext()}`} 
                        onClick={(id) => this.handleClick(`next_${getLPforNext()}`)} 
                    >
                    <i className="fa fa-angle-right"></i>
                    </a>
                </li>
                <li className={`last ${this.state.curPage === this.props.total ? 'disabled' : 'page'}`}>
                    <a 
                        id={`last_${this.props.total}`} 
                        onClick={(id) => this.handleClick(`last_${this.props.total}`)}
                    >
                    <i className="fa fa-angle-double-right"></i>
                    </a>
                </li>
            </ul>
        );
    }
}

export default Pagination;